// Centralized API configuration for PeptideForge
// Auto-detects the correct API URL for preview, local, and production environments.
//
// Critical: in production (e.g. peptideforge.co.uk) we MUST use same-origin
// requests. If the bundle was built with REACT_APP_BACKEND_URL pointing to the
// preview domain, that becomes a cross-origin call and Chrome's third-party
// cookie policy blocks `credentials: 'include'` → "Failed to fetch".

const PREVIEW_HOST_SUFFIXES = [
  '.preview.emergentagent.com',
  '.emergentagent.com',
];

const isPreviewHost = (hostname) =>
  PREVIEW_HOST_SUFFIXES.some((suffix) => hostname.endsWith(suffix));

const isLocalHost = (hostname) =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');

/**
 * Returns the API base URL.
 * Priority:
 *   1. If running on a real production domain (custom domain) → window.location.origin
 *      (same-origin → no third-party cookie issues, works in Chrome/Edge/Safari)
 *   2. If running on a preview/localhost host → use REACT_APP_BACKEND_URL when set
 *   3. Fallback → window.location.origin
 */
export const getApiBaseUrl = () => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }

  const { hostname, origin } = window.location;

  // PRODUCTION (custom domain) → always same-origin
  if (!isPreviewHost(hostname) && !isLocalHost(hostname)) {
    return origin;
  }

  // PREVIEW / LOCAL → honor build-time env var if set
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim() !== '') {
    return envUrl.trim();
  }

  return origin;
};

export const getApiUrl = () => `${getApiBaseUrl()}/api`;

export const API_BASE_URL = getApiBaseUrl();
export const API = getApiUrl();

export default API;
